export default {
    VIRTUAL_GUARD: 'VIRTUAL_GUARD',
    APPOINTMENT: 'APPOINTMENT',
    DEFERRED: 'DEFERRED'
};
